import React from "react";
import { SMS_HREF, getCurrentTier } from "./constants";
import { track } from "@/lib/analytics";

export function PromoBar() {
  const tier = getCurrentTier();
  return (
    <div
      className="bg-[#0A0A0A] text-[#FFFFFF] text-center text-xs sm:text-sm py-2 px-4"
      data-testid="promo-bar"
    >
      <span
        className={`font-bold uppercase tracking-[0.18em] mr-2 ${tier.promoBadgeClass}`}
      >
        {tier.promoBadgeLabel}
      </span>
      <span className="font-semibold">{tier.promoText}</span>
      <span className="hidden sm:inline opacity-70 mx-2">·</span>
      <a
        href={SMS_HREF}
        onClick={() => track("text_gutters_click", { location: "promo_bar" })}
        className={`hidden sm:inline underline underline-offset-2 ${tier.promoCtaClass}`}
        data-testid="promo-bar-cta"
      >
        {tier.promoCtaText}
      </a>
    </div>
  );
}
